import React from 'react';
import StatusFilter from './StatusFilter';
import BudgetWarningsFilter from './BudgetWarningsFilter';
import BudgetRangeFilter from './BudgetRangeFilter';
import CompletionRangeFilter from './CompletionRangeFilter';
import DisplayOptions from './DisplayOptions';

const FilterPanel = ({
  showFilterOptions,
  statusOptions,
  budgetWarningOptions,
  filters,
  toggleStatusFilter,
  setStatusFilterOnly,
  toggleBudgetWarningFilter,
  setBudgetWarningFilterOnly,
  updateBudgetFilter,
  updateCompletionFilter,
  showMonthHeaders,
  setShowMonthHeaders,
  clearAllFilters,
  setShowFilterOptions
}) => {
  if (!showFilterOptions) return null;
  
  return (
    <div className="mb-6 bg-white dark:bg-gray-800 shadow overflow-hidden sm:rounded-lg p-4 ring-1 ring-gray-200 dark:ring-gray-700">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* Left column: Status and Budget Warnings */}
        <div>
          <StatusFilter 
            statusOptions={statusOptions}
            filters={filters}
            toggleStatusFilter={toggleStatusFilter}
            setStatusFilterOnly={setStatusFilterOnly}
          />
          
          <BudgetWarningsFilter
            budgetWarningOptions={budgetWarningOptions}
            filters={filters}
            toggleBudgetWarningFilter={toggleBudgetWarningFilter}
            setBudgetWarningFilterOnly={setBudgetWarningFilterOnly}
          />
        </div>
        
        {/* Middle column: Budget and Completion Ranges */}
        <div>
          <BudgetRangeFilter
            filters={filters}
            updateBudgetFilter={updateBudgetFilter}
          />
          
          <CompletionRangeFilter
            filters={filters}
            updateCompletionFilter={updateCompletionFilter}
          />
        </div>
        
        {/* Right column: Group by Month and other display options */}
        <div>
          <DisplayOptions
            showMonthHeaders={showMonthHeaders}
            setShowMonthHeaders={setShowMonthHeaders}
          />
        </div>
      </div>
      
      {/* Filter Actions at bottom */}
      <div className="mt-6 flex justify-between border-t border-gray-200 dark:border-gray-700 pt-4">
        <button
          type="button"
          onClick={clearAllFilters}
          className="text-sm text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100"
        >
          Clear all filters
        </button>
        <button
          type="button"
          onClick={() => setShowFilterOptions(false)}
          className="text-sm font-medium bg-indigo-600 text-white px-3 py-1.5 rounded-md hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2"
        >
          Done
        </button>
      </div>
    </div>
  );
};

export default FilterPanel;